module.exports = __webpack_public_path__ + "static/media/country_icon.6f6d43f5.svg";